import { computed } from 'mobx';
import Collection from '~/glm/models/collection';

class EventCollection extends Collection {
  @computed
  get weddingEvent() {
    return this.find(event => event.isWeddingEvent);
  }

  @computed
  get receptionEvent() {
    return this.find(event => event.type === 'Reception');
  }

  @computed
  get nonReceptionEvents() {
    return this.filter(event => event !== this.receptionEvent);
  }

  @computed
  get receptionSameAsCeremony() {
    return (
      this.weddingEvent.venue === this.receptionEvent.venue && this.weddingEvent.address === this.receptionEvent.address
    );
  }

  @computed
  get eventQuestions() {
    const eventWithQuestions = this.filter(event => event.questions.length);
    const eventQuestions = eventWithQuestions.reduce((arr, event) => [...arr, ...event.questions], []);
    return eventQuestions;
  }

  @computed
  get rsvpEnabled() {
    const eventWithRsvp = this.find(event => event.requireRsvp === true);
    return !!eventWithRsvp;
  }
}

export default EventCollection;
